/* istanbul ignore file */
import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ModalWindowComponent } from '../modal-window/modal-window.component';
import { ADPComponentsModule } from 'digital-core';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'global-modal-window',
    templateUrl: './global-modal-window.component.html',
    styleUrls: ['./global-modal-window.component.scss'],
    imports: [ModalWindowComponent, ADPComponentsModule, MatButton]
})
export class GlobalModalWindowComponent {

  constructor(
    public dialogRef: MatDialogRef<GlobalModalWindowComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  closeModal() {
    this.dialogRef.close();
  }
}
